import { useTranslation } from 'react-i18next'
import { Button } from '@/components/button'
import { fetchFile, downloadFile } from '@/utils/download-file'
import { ContentWrapper, AreaTitle, StyledPanel, StyledRow, StyledLabel } from './elements'

type PadAgreementProps = {
  paymentRequestId: string
}

const PadAgreement: React.FC<PadAgreementProps> = ({ paymentRequestId }) => {
  const { t } = useTranslation()

  const downloadPdf = () => {
    const download = async () => {
      let blob
      try {
        blob = await fetchFile(`/payment_request/${paymentRequestId}/pad_agreement.pdf`)
      } catch (e) {
        console.log(e)
      }
      downloadFile(blob, `PAD Agreement ${paymentRequestId}.pdf`)
    }
    download()
  }

  return (
    <ContentWrapper>
      <AreaTitle>{t('b.payment.view.pad_agreement.title', 'PAD Agreement')}</AreaTitle>
      <StyledPanel hSpace={24} vSpace={24}>
        <StyledRow>
          <StyledLabel bottom={0}>
            {t('b.payment.view.pad_agreement.label', 'PAD Agreement')}
          </StyledLabel>
          <Button target="_blank" theme="text" size="medium" space="none" onClick={downloadPdf}>
            {t('b.payment.view.download_pdf.button', 'Download PDF')}
          </Button>
        </StyledRow>
      </StyledPanel>
    </ContentWrapper>
  )
}

export default PadAgreement
